import { render } from "./editar-gasto.vue?vue&type=template&id=3661a20e&scoped=true"
import script from "./editar-gasto.vue?vue&type=script&lang=js"
export * from "./editar-gasto.vue?vue&type=script&lang=js"

import "./editar-gasto.vue?vue&type=style&index=0&id=3661a20e&scoped=true&lang=css"
import "./editar-gasto.vue?vue&type=style&index=1&id=3661a20e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3661a20e"]])

export default __exports__